import React, { useEffect, useState } from "react";
import ReactDOM from 'react-dom';
import { schoolViewModel } from "../school.view.model";
import { useHistory } from "react-router-dom";
import PartnerHeader from "../PartnerHeader";
import { Col, Container, Image, Row, Spinner } from "react-bootstrap";
import { getUserProfileUrl } from "../../../../utils/camp.utils";
import { Avatar, Box, Card, CardContent, Divider, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { HiOutlineChevronLeft } from "@react-icons/all-files/hi/HiOutlineChevronLeft";
import { ALLMOOD, ANGRY, ANNOYED, CALM, CONFIDENT, EXCITED, HAPPY, SCARED, WORRIED } from "../../../../constants/moodType.constants";
import Happymood from '../../../../assets/images/mood-img/Happy.svg';
import Calmmood from '../../../../assets/images/mood-img/Calm.svg';
import Excitedmood from '../../../../assets/images/mood-img/Excited.svg';
import Worriedmood from '../../../../assets/images/mood-img/Worried.svg';
import Angrymood from '../../../../assets/images/mood-img/Angry.svg';
import Scaredmood from '../../../../assets/images/mood-img/Scared.svg';
import Confidentmood from '../../../../assets/images/mood-img/Confident.svg';
import Annoyedmood from '../../../../assets/images/mood-img/Annoyed.svg';
import { CHALLENGE_ROUTE, SHARE_CREATION_ROUTE_BANNER } from "../../../../constants/routes.constants";
import ReactTimeAgo from 'react-time-ago';
import { useAuth } from "../../../auth/Auth";
import InfiniteScroll from "react-infinite-scroller";
import IIcon from '../../../../assets/icon/PRINT.svg';
import NoKidActivityImg from '../../../../assets/images/tour/no-kid-activity.svg';
import CampNoDataTooltip from '../camp_tour/CampNoDataTooltip';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    backgroundColor: '#fff',
    borderRadius: 8,
    padding: 2,
    boxShadow: 'none',
  },
  card: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 1,
    padding: 1,
    borderRadius: 8,
    boxShadow: 'none !important',
  },
  avatar: {
    marginRight: 2,
    cursor: 'pointer',
    alignSelf: 'start',
    marginTop: '20px',
  },
  content: {
    flex: '1 0 auto',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 2,
  },
  message: {
    display: 'inline-block',
    padding: '0.5, 1',
    borderRadius: 4,
  },
  icon: {
    paddingBottom: '5px',
  },
  activityImage: {
    height: '160px',
    width: '250px',
  },
  username: {
    color: 'blue',
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  noDataFound: {
    display: 'flex',
    justifyContent: 'center',
  },
}));

const KidActivity = () => {
  const _PAGE_LIMIT = 9;
  const history = useHistory();
  const { fetchAPI } = useAuth();
  const dependent = JSON.parse(history?.location?.state?.dependent);
  const [logs, setLogs] = useState([]);
  const classes = useStyles();
  const [isLoading, setIsLoading] = useState(true);
  const [showNoDataTooltip, setShowNoDataTooltip] = useState(false);

  const NoActivity = [
    {
      element: '#no-kid-activity',
      intro: `
      <div class="custom-tour-step">
        <img src="${NoKidActivityImg}" alt="Camp Master" class="tour-avatar" />
        <h3>Monitor Child Activities</h3>
        <p>Where you can access a real-time feed of updates and interactions.</p>
      </div>`,
      position: 'auto',
      tooltipClass: 'custom-tooltip', // Custom tooltip class for CSS
      highlightClass: 'custom-highlight', // Custom highlight class for step highlighting
    },
  ];
  const [query, setQuery] = useState({
    limit: _PAGE_LIMIT,
    has_more: true,
  });

  const getDependentLogs = () => {
    fetchAPI(schoolViewModel.getDependentLogs, query, dependent?.id, logs)
      .then((res) => {
        ReactDOM.unstable_batchedUpdates(() => {
          setLogs(res.List);
          setQuery(res.query);
          setIsLoading(false);
        });
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getDependentLogs();
  }, []);

  const getMoodImage = (mood) => {
    switch (mood) {
      case HAPPY:
        return Happymood;
      case EXCITED:
        return Excitedmood;
      case CALM:
        return Calmmood;
      case WORRIED:
        return Worriedmood;
      case ANGRY:
        return Angrymood;
      case SCARED:
        return Scaredmood;
      case CONFIDENT:
        return Confidentmood;
      case ANNOYED:
        return Annoyedmood;
      default:
        break;
    }
  };

  const getActivity = (activity) => {
    switch (activity?.change_message?.action_type) {
      case 'Dependent Mood':
        return (
          <>
            <Image
              height={20}
              src={getMoodImage(activity?.change_message?.action?.mood)}
              alt={activity?.change_message?.action?.mood}
            />{' '}
            Checked as {activity?.change_message?.action?.mood}.
            <ReactTimeAgo date={activity?.action_time} />
          </>
        );

      case 'Add Creations':
        return activity?.change_message?.action?.challenge_id ? (
          <p>
            Submitted a creation under{' '}
            <span
              onClick={() =>
                onChallengeClick(activity?.change_message?.action?.challenge_id)
              }
              className={classes.username}
            >
              {activity?.change_message?.action?.challenge_title}
            </span>{' '}
            creation. <ReactTimeAgo date={activity?.action_time} />
          </p>
        ) : (
          <p>
            Submitted a creation. <ReactTimeAgo date={activity?.action_time} />
          </p>
        );

      case 'Creation of the day':
        return (
          <p>
            Creation of the day. <ReactTimeAgo date={activity?.action_time} />
          </p>
        );

      case 'Add Binkies':
        return (
          <p>
            Gave a binky to{' '}
            <span
              onClick={() =>
                history.push(
                  `/${activity?.change_message?.action?.creation_user}`
                )
              }
              className={classes.username}
            >
              {activity?.change_message?.action?.creation_user}
            </span>
            's creation. <ReactTimeAgo date={activity?.action_time} />
          </p>
        );

      case 'Accept Challenge':
        return (
          <p>
            Accepted{' '}
            <span
              onClick={() =>
                onChallengeClick(activity?.change_message?.action?.id)
              }
              className={classes.username}
            >
              {activity?.change_message?.action?.title}
            </span>{' '}
            challenge. <ReactTimeAgo date={activity?.action_time} />
          </p>
        );

      case 'Add Complement':
        return (
          <p>
            Complimented{' '}
            <span
              onClick={() =>
                history.push(
                  `/${activity?.change_message?.action?.creation_user}`
                )
              }
              className={classes.username}
            >
              {activity?.change_message?.action?.creation_user}
            </span>
            's creation'. <ReactTimeAgo date={activity?.action_time} />
          </p>
        );

      default:
        break;
    }
  };

  const getActivityImage = (activity) => {
    switch (activity?.action_type) {
      case 'Dependent Mood':
        return '';

      case 'Add Creations':
        return (
          <Image
            style={{ cursor: 'pointer' }}
            onClick={() => handleCreationClick(activity?.action?.id)}
            className={classes.activityImage}
            src={activity?.action?.url}
            alt="creation"
          />
        );

      case 'Creation of the day':
        return (
          <Image
            style={{ cursor: 'pointer' }}
            onClick={() => handleCreationClick(activity?.action?.id)}
            className={classes.activityImage}
            src={activity?.action?.url}
            alt="creation"
          />
        );

      case 'Add Binkies':
        return (
          <Image
            style={{ cursor: 'pointer' }}
            onClick={() => handleCreationClick(activity?.action?.id)}
            className={classes.activityImage}
            src={activity?.action?.url}
            alt="creation"
          />
        );

      case 'Accept Challenge':
        return (
          <Image
            style={{ cursor: 'pointer' }}
            onClick={() => onChallengeClick(activity?.action?.id)}
            className={classes.activityImage}
            src={activity?.action?.url}
            alt="challenge"
          />
        );

      case 'Add Complement':
        return (
          <Image
            style={{ cursor: 'pointer' }}
            onClick={() => handleCreationClick(activity?.action?.id)}
            className={classes.activityImage}
            src={activity?.action?.url}
            alt="creation"
          />
        );
      default:
        break;
    }
  };

  const onChallengeClick = (challenge_id) => {
    let path = CHALLENGE_ROUTE;
    let encodeQuery = btoa(`{"id":${challenge_id}, "slug":"challenge"}`);
    history.push({
      pathname: path,
      search: `?encrypt=${encodeQuery}`,
    });
  };

  const handleCreationClick = (creationId) => {
    const encoded = btoa(`{"id":${creationId}, "slug":"creation"}`);
    history.push({
      pathname: SHARE_CREATION_ROUTE_BANNER,
      search: `?encrypt=${encoded}`,
    });
  };

  const handleGobackClick = () => {
    history.goBack();
  };

  const handleNoDataClick = () => {
    setShowNoDataTooltip(true);
  };

  return (
    <div className="treehouse-details partner-setting-wrapper partner-wrapper-main">
      <PartnerHeader />
      <CampNoDataTooltip
        showTooltip={showNoDataTooltip}
        setShowTooltip={setShowNoDataTooltip}
        step={NoActivity}
      />
      <div
        className="treehouse-back new-payment-plan-back-btn"
        role="button"
        onClick={handleGobackClick}
      >
        <span className="back-btn">
          <HiOutlineChevronLeft />
        </span>
      </div>
      <Container className="setting-container setting-wrap" fluid="md">
        <Row className="middle-section guardian-row-box">
          <Col
            className="welcome"
            style={{ paddingTop: '20px', paddingBottom: '20px' }}
          >
            {dependent?.username} timeline
          </Col>
          <Row className="kid-box vertical-height activated insights-dashboard">
            <InfiniteScroll
              pageStart={0}
              loadMore={getDependentLogs}
              hasMore={query.has_more}
              threshold={150}
              style={{ width: '100%' }}
              className="home-feed-spinner-wrapper"
              loader={
                <Spinner
                  key={0}
                  className="home-feed-spinner"
                  animation="border"
                  variant="info"
                />
              }
            >
              <Box className={`${classes.root} short_second_card`}>
                {!isLoading ? (
                  logs.length > 0 ? (
                    logs.map((item, index) => (
                      <React.Fragment key={index}>
                        <Card className={classes.card}>
                          <Avatar
                            src={getUserProfileUrl(dependent)}
                            className={classes.avatar}
                          />
                          <CardContent className={classes.content}>
                            <Typography variant="h6">
                              {dependent?.username}
                            </Typography>
                            <Typography
                              className="time-compliments"
                              variant="caption"
                              color="textSecondary"
                            >
                              {getActivity(item)}
                            </Typography>
                            {getActivityImage(item?.change_message)}
                          </CardContent>
                        </Card>
                      </React.Fragment>
                    ))
                  ) : (
                    <div
                      className="insights-text no-data-found"
                      id="no-kid-activity"
                    >
                      <div className="text-wrapper">
                        <Image
                          src={IIcon}
                          alt="no-data"
                          className="add-pointer"
                          onClick={handleNoDataClick}
                        />
                        <Typography
                          variant="body1"
                          style={{ color: '#321b6d' }}
                        >
                          There are no activities yet in {dependent?.username}
                          's timeline.
                        </Typography>
                      </div>
                    </div>
                  )
                ) : (
                  ''
                )}
              </Box>
            </InfiniteScroll>
          </Row>
        </Row>
      </Container>
    </div>
  );
};

export default KidActivity;